__turbopack_context__.v({
  "secondary-header": "secondary-header-module-scss-module__AMuG2G__secondary-header",
});
